import Lottie from 'lottie-react';
import { PageLoadingStyles } from './PageLoading.styles';
import loadingLottie from '../../../assets/Lottie/loading.json';

export default function PageLoading() {
  return (
    <PageLoadingStyles>
      <div className="d-flex content-loading">
        <div className="text-center">
          <Lottie
            animationData={loadingLottie}
            loop
          />
        </div>
      </div>
    </PageLoadingStyles>
  );
}
